<template>
  <div v-frag>
    <b-row>
      <b-colxx xxs="12">
        <piaf-breadcrumb :heading="$t('menu.create')" />
        <div class="separator mb-5"></div>
      </b-colxx>
    </b-row>
    <b-row>
      <b-colxx xxs="12">
        <b-card class="mb-4">
          <b-form @submit.prevent="onSubmit" class="av-tooltip">
            <b-form-group :label="`${$t('pages.faq.question')} (EN)`">
              <b-form-input
                type="text"
                v-model="$v.createForm.questionEn.$model"
                :state="!$v.createForm.questionEn.$error"
              />
              <b-form-invalid-feedback v-if="!$v.createForm.questionEn.required">
                {{ $t('formErrors.enterQuestion') }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group :label="`${$t('pages.faq.question')} (RU)`">
              <b-form-input
                type="text"
                v-model="$v.createForm.questionRu.$model"
                :state="!$v.createForm.questionRu.$error"
              />
              <b-form-invalid-feedback v-if="!$v.createForm.questionRu.required">
                {{ $t('formErrors.enterQuestion') }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group :label="`${$t('pages.faq.answer')} (EN)`">
              <b-form-textarea
                spellcheck="false"
                v-model="$v.createForm.answerEn.$model"
                :state="!$v.createForm.answerEn.$error"
                rows="3"
              ></b-form-textarea>

              <b-form-invalid-feedback v-if="!$v.createForm.answerEn.required">
                {{ $t('formErrors.enterAnswer') }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group :label="`${$t('pages.faq.answer')} (RU)`">
              <b-form-textarea
                spellcheck="false"
                v-model="$v.createForm.answerRu.$model"
                :state="!$v.createForm.answerRu.$error"
                rows="3"
              ></b-form-textarea>

              <b-form-invalid-feedback v-if="!$v.createForm.answerRu.required">
                {{ $t('formErrors.enterAnswer') }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group :label="$t('pages.faq.sort')">
              <b-form-input
                type="number"
                v-model="$v.createForm.sort.$model"
                :state="!$v.createForm.sort.$error"
                min="0"
              />
              <b-form-invalid-feedback v-if="!$v.createForm.sort.required">
                {{ $t('formErrors.enterSort') }}
              </b-form-invalid-feedback>
              <b-form-invalid-feedback v-else-if="!$v.createForm.sort.numeric">
                {{ $t('formErrors.mustBeNumber') }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-button
              type="submit"
              variant="primary"
              :disabled="isLoading"
              :class="{
                'btn-multiple-state mt-2': true,
                'show-spinner': isLoading
              }"
            >
              <span class="spinner d-inline-block">
                <span class="bounce1"></span>
                <span class="bounce2"></span>
                <span class="bounce3"></span>
              </span>
              <span class="label">
                {{ $t('buttons.save') }}
              </span>
            </b-button>
          </b-form>
        </b-card>
      </b-colxx>
    </b-row>
  </div>
</template>

<script>
const { required, numeric } = require('vuelidate/lib/validators')

export default {
  data: () => ({
    isLoading: false,
    createForm: {
      questionEn: '',
      questionRu: '',
      answerEn: '',
      answerRu: '',
      sort: 0
    }
  }),
  validations: {
    createForm: {
      questionEn: { required },
      questionRu: { required },
      answerEn: { required },
      answerRu: { required },
      sort: { required, numeric }
    }
  },
  methods: {
    addNotification(type, title, message) {
      this.$notify(type, title, message, { duration: 2000, permanent: false })
    },
    onSubmit() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        const payload = {
          question_en: this.createForm.questionEn,
          question_ru: this.createForm.questionRu,
          answer_en: this.createForm.answerEn,
          answer_ru: this.createForm.answerRu,
          sort: this.createForm.sort
        }

        this.$store.dispatch('faq/createSingleFaq', {
          payload,
          vm: this
        })
      }
    }
  }
}
</script>
